export const Resources = [
  {
    path: '/resources/:app_module_id',
    name: 'resources.index',
    component: () => import('@/pages/Resources/ResourcesModule')
  },
  {
    path: '/resources/:app_module_id/:id',
    name: 'resources.item',
    component: () => import('@/pages/Resources/ResourcesPage')
  },
  {
    path: '/resources/:app_module_id/:folder_id/:id',
    name: 'resources.view',
    component: () => import('@/pages/Resources/ResourcesView')
  }
]
